var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',[(!_vm.hideName)?[_c('p',{staticClass:"mb-0"},[_c('b',[_vm._v(_vm._s(_vm.name || 'Qualifications'))])])]:_vm._e(),_vm._v(" "),_vm._l(((_vm.value || [])),function(ref){
var name = ref.name;
var date = ref.date;
return _c('p',{key:name,staticStyle:{"line-height":"1.2rem"}},[_c('span',[_vm._v(_vm._s(name))]),_vm._v(" "),(date)?[_c('br'),_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatDate(date, 'MMM YYYY')))])]:_vm._e()],2)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba0045ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/QualificationsShow.vue
// module id = Rp/X
// module chunks = 0 112